export const predata = [
  {
    id: "42836636-6eb8-4ab3-8ff0-724f4a73c978",
    name: "Sagar Gupta",
    email: "sg85207@gmail.com",
  },
];
